import { Navigate } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner';
import { useExhibitorAuthContext } from '../../Context/AuthContex/ExhibitorAuthContext';

interface PropType {
  component: JSX.Element;
}
const PrivateRoute = ({ component }: PropType) => {
  const {
    state: { exhibitorUser },
    isLoading,
  } = useExhibitorAuthContext();

  if (isLoading) {
    return (
      <div className='text-center' style={{ marginTop: '200px' }}>
        <Spinner
          animation='border'
          variant='primary'
          style={{ height: '60px', width: '60px' }}
        />
      </div>
    );
  }
  if (exhibitorUser?.token) {
    return component;
  } else {
    return <Navigate to='/login' />;
  }
};

export default PrivateRoute;
